import { useMutation } from '@tanstack/react-query'

import { generateCustomBriefFromContent } from '../api'

const useGenerateCustomBriefFromContentMutation = () => {
  return useMutation({ mutationFn: generateCustomBriefFromContent })
}

export default useGenerateCustomBriefFromContentMutation
